import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const StatusBullet = ({
  className,
  size = 'md',
  color = 'neutral',
  sx = {},
  ...rest
}) => {
  const sizeMap = {
    sm: 8,
    md: 16,
    lg: 24
  };

  const colorMap = theme => ({
    neutral: theme.palette.grey[500],
    primary: theme.palette.primary.main,
    info: theme.palette.info.main,
    success: theme.palette.success.main,
    warning: theme.palette.warning.main,
    danger: theme.palette.error.main
  });

  return (
    <Box
      component="span"
      className={className}
      sx={theme => ({
        display: 'inline-block',
        borderRadius: '50%',
        flexGrow: 0,
        flexShrink: 0,
        width: sizeMap[size],
        height: sizeMap[size],
        bgcolor: colorMap(theme)[color],
        ...sx
      })}
      {...rest}
    />
  );
};

StatusBullet.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf([
    'neutral',
    'primary',
    'info',
    'success',
    'warning',
    'danger'
  ]),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  sx: PropTypes.object
};

export default StatusBullet;